/*
 * Wodora — drobne poprawki UX poza główną paczką motywu (js.shrinetheme.com).
 * Szuflada koszyka: usunięcie ostatniego produktu zamyka szufladę i wraca
 * na stronę, na której stoi klient, zamiast pokazywać pusty stan.
 */
(function () {
  function watchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    // Stan wyjściowy: szuflada otwarta z pustym koszykiem NIE ma się zamykać sama.
    var hadItems = !drawer.classList.contains('is-empty');

    new MutationObserver(function () {
      var isEmpty = drawer.classList.contains('is-empty');
      var isOpen = drawer.classList.contains('active');

      if (isEmpty && hadItems && isOpen && typeof drawer.close === 'function') {
        drawer.close();
      }
      hadItems = !isEmpty;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    return true;
  }

  if (!watchCartDrawer()) {
    document.addEventListener('DOMContentLoaded', watchCartDrawer);
  }
})();

/*
 * Koszyk: napis nad upsellem butelki dopasowany do zawartości koszyka.
 * Bez wyliczanki „Druga Butelka" przy pustym koszyku i bez „Druga",
 * kiedy klient ma już dwie. Sam upsell i ceny zostają nietknięte.
 */
(function () {
  var HANDLE_BUTELKI = 'wodora-vodikova-lahev';
  var SELEKTOR = 'cart-drawer .product__text-container-text_with_icon_YxrRPR strong';
  var LICZEBNIKI = ['Druhá', 'Třetí', 'Čtvrtá', 'Pátá', 'Šestá'];
  var OFERTA = ' láhev za 990 Kč místo 1 290 Kč';
  var wTrakcie = false;
  var daneButelki = null;     // { id, cenaTekst } — pobierane raz
  var cenaZUpsella = null;
  var porownanieZUpsella = null;    // oryginalna cena z kafelka (dla 2. butelki i dalej)

  function tekstDla(sztuk) {
    if (sztuk <= 0) return 'Vodíková láhev za 1 290 Kč místo 1 790 Kč';
    if (sztuk <= LICZEBNIKI.length) return LICZEBNIKI[sztuk - 1] + OFERTA;
    return 'Další' + OFERTA;
  }

  function pobierzButelke() {
    if (daneButelki) return Promise.resolve(daneButelki);
    return fetch('/products/' + HANDLE_BUTELKI + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        daneButelki = {
          id: String(prod.id),
          cenaTekst: (prod.price / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč'
        };
        return daneButelki;
      });
  }

  // Kafelek upsella pokazuje cenę drugiej butelki (179,99) niezależnie od koszyka.
  // Przy koszyku bez butelki klient płaci pełne 219,99 — więc tam pokazujemy prawdę.
  function poprawCeneKafelka(sztuk) {
    if (!daneButelki) return;

    var kontenery = document.querySelectorAll('cart-drawer .upsell__container');
    for (var i = 0; i < kontenery.length; i++) {
      var pole = kontenery[i].querySelector('form input[name="product-id"]');
      if (!pole || pole.value !== daneButelki.id) continue;

      var cena = kontenery[i].querySelector('.upsell__price .regular-price');
      var porownanie = kontenery[i].querySelector('.upsell__price .compare-price');
      if (!cena) return;

      // zapamiętujemy oryginały raz, zanim cokolwiek podmienimy
      if (cenaZUpsella === null && cena.textContent.trim() !== daneButelki.cenaTekst) {
        cenaZUpsella = cena.textContent.trim();
      }
      if (porownanieZUpsella === null && porownanie) {
        porownanieZUpsella = porownanie.textContent.trim();
      }

      // bez butelki: pełna cena i katalogowa przekreślona
      // z butelką: cena kolejnej sztuki, a przekreślona = cena pełna, żeby zgadzała się z napisem
      var docelowa = sztuk <= 0 ? daneButelki.cenaTekst : (cenaZUpsella || cena.textContent.trim());
      var docelowePorownanie = sztuk <= 0 ? porownanieZUpsella : daneButelki.cenaTekst;

      if (cena.textContent.trim() !== docelowa) cena.textContent = docelowa;
      if (porownanie && docelowePorownanie && porownanie.textContent.trim() !== docelowePorownanie) {
        porownanie.textContent = docelowePorownanie;
      }
      return;
    }
  }

  function odswiez() {
    var el = document.querySelector(SELEKTOR);
    if (!el || wTrakcie) return;

    wTrakcie = true;
    pobierzButelke()
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sztuk = (cart.items || []).reduce(function (suma, poz) {
          return poz.handle === HANDLE_BUTELKI ? suma + poz.quantity : suma;
        }, 0);

        var docelowy = tekstDla(sztuk);
        var cel = document.querySelector(SELEKTOR);
        if (cel && cel.textContent.trim() !== docelowy) cel.textContent = docelowy;

        poprawCeneKafelka(sztuk);
      })
      .catch(function () { /* koszyk niedostępny — zostaje napis z ustawień */ })
      .finally(function () { wTrakcie = false; });
  }

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    odswiez();

    var czekanie;
    new MutationObserver(function () {
      clearTimeout(czekanie);
      czekanie = setTimeout(odswiez, 120);
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    return true;
  }

  // Motyw aktualizuje koszyk przez fetch — łapiemy to, żeby napis nadążał
  // także wtedy, gdy szuflada nie przerysowuje się w całości.
  var oryginalnyFetch = window.fetch;
  if (typeof oryginalnyFetch === 'function') {
    window.fetch = function () {
      var adres = arguments[0];
      var url = typeof adres === 'string' ? adres : (adres && adres.url) || '';
      var wynik = oryginalnyFetch.apply(this, arguments);

      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        wynik.then(function () { setTimeout(odswiez, 250); }).catch(function () {});
      }
      return wynik;
    };
  }

  if (!start()) document.addEventListener('DOMContentLoaded', start);
})();
